// Email service helper functions
import emailjs from '@emailjs/browser';

// Option 1: EmailJS (recommended for static sites)
export const sendEmailViaEmailJS = async (formData, userConfig) => {
  try {
    const { serviceId, templateId, userId } = userConfig;
    
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      subject: formData.subject,
      message: formData.message,
      to_email: 'dibamizan.w@gmail.com',
      reply_to: formData.email
    };

    const result = await emailjs.send(
      serviceId,
      templateId,
      templateParams,
      userId
    );
    
    console.log('EmailJS success:', result);
    return result;
  } catch (error) {
    console.error('EmailJS error:', error);
    throw error;
  }
};

// Simplified EmailJS function for portfolio contact form
export const sendPortfolioContactEmail = async (formData) => {
  try {
    // NOTE: These are example values - you need to replace with your actual EmailJS credentials
    // To set up EmailJS:
    // 1. Go to https://emailjs.com and create an account
    // 2. Create an email service (Gmail, Outlook, etc.)
    // 3. Create an email template
    // 4. Replace the values below with your actual credentials
    
    const EMAILJS_CONFIG = {
      serviceId: 'service_aolpvzb', // Your EmailJS Gmail service ID
      templateId: 'template_zqq315x', // Your EmailJS template ID  
      userId: 'eLoKe02LOCgkGcxnL' // Your EmailJS API key/user ID
    };

    console.log('EmailJS configured! Sending email to dibamizan.w@gmail.com with:', formData);

    return await sendEmailViaEmailJS(formData, EMAILJS_CONFIG);
  } catch (error) {
    console.error('Portfolio contact email error:', error);
    throw error;
  }
};

// Option 2: Formspree (requires setup - see instructions below)
export const sendEmailViaFormspree = async (formData) => {
  try {
    // NOTE: Replace 'YOUR_FORM_ID' with your actual Formspree form ID
    // To get a Formspree form ID:
    // 1. Go to https://formspree.io and create a free account
    // 2. Create a new form
    // 3. Copy the form ID from the endpoint URL
    // 4. Replace 'YOUR_FORM_ID' below with your actual form ID
    const FORM_ID = 'YOUR_FORM_ID'; // Replace this with your actual form ID
    
    if (FORM_ID === 'YOUR_FORM_ID') {
      // For now, simulate a successful response for development
      console.log('Formspree form not configured yet. Form data:', formData);
      return Promise.resolve({ 
        success: true, 
        message: 'Form would be submitted via Formspree' 
      });
    }

    const response = await fetch(`https://formspree.io/f/${FORM_ID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
        _replyto: formData.email,
        _subject: `Portfolio Contact: ${formData.subject}`
      }),
    });

    if (response.ok) {
      return await response.json();
    } else {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Submission failed');
    }
  } catch (error) {
    console.error('Formspree error:', error);
    throw error;
  }
};

// Option 3: Netlify Forms (if deployed on Netlify)
export const submitToNetlifyForm = async (formData) => {
  try {
    const response = await fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        'form-name': 'contact',
        'name': formData.name,
        'email': formData.email,
        'subject': formData.subject,
        'message': formData.message
      })
    });

    if (response.ok) {
      return { success: true };
    } else {
      throw new Error('Submission failed');
    }
  } catch (error) {
    console.error('Netlify form error:', error);
    throw error;
  }
};

// Validator helper
export const validateForm = (formData) => {
  const errors = {};
  
  if (!formData.name.trim()) {
    errors.name = 'Name is required';
  }
  
  if (!formData.email.trim()) {
    errors.email = 'Email is required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = 'Please enter a valid email address';
  }
  
  if (!formData.subject.trim()) {
    errors.subject = 'Subject is required';
  }
  
  if (!formData.message.trim()) {
    errors.message = 'Message is required';
  } else if (formData.message.trim().length < 10) {
    errors.message = 'Message must be at least 10 characters';
  }
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};
